var _rect, _g, _circle, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessTrafficLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3162_82946)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 14,
    fill: "#411700"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3162_82946)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -15.1715,
    cy: 98.5102,
    r: 59.2367,
    fill: "#EE7C00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter1_f_3162_82946)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.0773,
    cy: -10.3699,
    r: 22.8293,
    fill: "#3C110C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3162_82946)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.7266,
    cy: 14.8349,
    r: 19.5195,
    fill: "black",
    fillOpacity: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_3162_82946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4008 56.8661C10.4341 58.5575 7.53494 59.6052 4.16863 60.2046C-4.50595 61.7471 -12.9474 59.3222 -19.4478 53.4189C-21.0342 51.9786 -24.0448 48.0124 -25.0208 46.0777C-28.6679 38.8484 -28.9856 30.5942 -25.9086 23.001C-24.6591 19.9153 -22.0907 15.9288 -20.7429 14.9847C-19.0938 13.8296 -16.8975 14.2026 -15.7555 15.8328C-14.6596 17.3975 -14.84 18.7608 -16.4179 20.8422C-20.8146 26.6442 -21.9692 33.8149 -19.5869 40.507C-19.0349 42.0569 -18.8103 42.4551 -17.1048 44.902C-15.363 47.402 -15.1302 47.6738 -13.8198 48.7405C-10.9734 51.0578 -8.00687 52.4706 -4.58563 53.14C9.59086 55.9089 22.258 43.6758 19.9413 29.4522C19.4049 26.1565 17.6971 22.4286 15.6255 20.0278C15.0805 19.3977 14.5601 18.7886 14.4694 18.6733C14.0583 18.1498 13.8471 18.2358 12.9958 19.2756C12.5406 19.8308 11.9626 20.4292 11.7109 20.6055C11.1711 20.9836 10.1591 20.9129 9.63471 20.4603C9.29408 20.1713 4.78138 8.36579 4.68619 7.52516C4.61815 6.93471 4.96326 6.28575 5.56595 5.86359C6.11898 5.47622 6.37287 5.4934 11.3681 6.26823C20.5384 7.68993 19.9016 7.54893 20.3875 8.24263C20.9994 9.11626 20.8047 9.94478 19.695 11.2005C19.2184 11.7392 18.7894 12.2755 18.7357 12.3961C18.6682 12.5535 18.8898 12.8487 19.5549 13.4881C20.0557 13.9705 21.0609 15.1168 21.7852 16.038C30.1808 26.6922 29.0424 42.7203 19.2008 52.3628C17.4065 54.1212 15.1683 55.8589 13.4008 56.8661Z",
    fill: "#EF7C00"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_3162_82946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2962 7.03305C44.6233 5.94632 46.8606 5.33795 49.4206 5.09427C56.0175 4.46773 62.1973 6.80101 66.7096 11.6232C67.8108 12.7997 69.8255 15.9568 70.4389 17.4666C72.7314 23.1086 72.4654 29.3155 69.6952 34.8196C68.57 37.0564 66.4012 39.888 65.3333 40.5133C64.0265 41.2785 62.4029 40.8648 61.6464 39.573C60.9204 38.3331 61.1389 37.3222 62.4489 35.8583C66.0991 31.7775 67.4024 26.4727 66.0253 21.3107C65.7062 20.1152 65.5621 19.803 64.4331 17.8646C63.2801 15.8841 63.1222 15.6662 62.205 14.7865C60.2128 12.8756 58.0753 11.6354 55.5516 10.9247C45.0937 7.98322 34.8511 16.3799 35.719 27.1836C35.9199 29.6869 36.9724 32.5857 38.3787 34.5119C38.7488 35.0175 39.1017 35.5059 39.1627 35.5979C39.4389 36.0154 39.6025 35.9638 40.3041 35.2363C40.6792 34.848 41.149 34.4347 41.3485 34.3179C41.7762 34.0675 42.5305 34.1823 42.896 34.5536C43.1337 34.791 45.7955 43.9162 45.8155 44.5522C45.8305 44.999 45.5321 45.4644 45.0546 45.744C44.6164 46.0006 44.4271 45.9722 40.7299 45.0864C33.9425 43.4606 34.4112 43.6052 34.0893 43.0555C33.684 42.3632 33.8805 41.754 34.7891 40.8805C35.1793 40.5058 35.5335 40.13 35.5812 40.0428C35.6414 39.929 35.4933 39.6941 35.0338 39.1742C34.6879 38.782 34.0043 37.8613 33.5177 37.1265C27.8748 28.6272 29.707 16.6818 37.6733 10.0546C39.1257 8.84606 40.9096 7.68013 42.2962 7.03305Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3162_82946",
    x: -154.93,
    y: -41.2482,
    width: 279.517,
    height: 279.517,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40.2608,
    result: "effect1_foregroundBlur_3162_82946"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3162_82946",
    x: -61.2736,
    y: -113.721,
    width: 206.702,
    height: 206.702,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40.2608,
    result: "effect1_foregroundBlur_3162_82946"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3162_82946",
    x: -87.3146,
    y: -85.2062,
    width: 200.082,
    height: 200.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40.2608,
    result: "effect1_foregroundBlur_3162_82946"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_3162_82946",
    x: -28.0068,
    y: 5.61523,
    width: 55.4102,
    height: 55.043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25646
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.109617 0 0 0 0 0.0441667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3162_82946"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_3162_82946",
    x: 30.2471,
    y: 4.99414,
    width: 41.7373,
    height: 40.8901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.92109
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.223529 0 0 0 0 0.215686 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3162_82946"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3162_82946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessTrafficLogo);
export default __webpack_public_path__ + "static/media/business-traffic-logo.b49bb59f0136ca7010a09545c22a6fb8.svg";
export { ForwardRef as ReactComponent };